<div class="fs-2 with-close" mat-dialog-title>
    Commentaire sur le lead
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <p class="mb-2" *ngIf="lead.user"><b>{{ lead.user.firstname }} {{ lead.user.lastname }}</b><ng-container *ngIf="lead.ad"> · {{ lead.ad.title }}</ng-container></p>
    <form (ngSubmit)="onYesClick()">
        <mat-form-field class="lines-3">
            <mat-label>Commentaire</mat-label>
            <textarea matInput rows="6" [(ngModel)]="comment" name="comment"></textarea>
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Valider</ng-container>
    </button>
</div>
